import React, { useEffect } from "react";

/**
 * Development-only logger
 */
const devLog = (...args) => {
  if (process.env.NODE_ENV === "development") {
    console.log("[PaymentTable]", ...args);
  }
};

const PaymentTable = ({ payments }) => {

  /**
   * Log when component mounts or payments change
   */
  useEffect(() => {

    devLog("Component mounted / payments updated");

    if (!payments) {
      devLog("Payments prop is null or undefined");
      return;
    }

    if (!Array.isArray(payments)) {
      devLog("Payments prop is NOT array:", payments);
      return;
    }

    devLog("Payments count:", payments.length);

    if (payments.length > 0) {

      devLog("First payment object:", payments[0]);

      devLog("Payment fields check:", {
        id: payments[0].id,
        userName: payments[0].userName,
        userEmail: payments[0].userEmail,
        planName: payments[0].planName,
        amount: payments[0].amount,
        status: payments[0].status,
        razorpayOrderId: payments[0].razorpayOrderId,
        createdAt: payments[0].createdAt,
      });

    } else {

      devLog("Payments array is empty");

    }

  }, [payments]);


  /**
   * Render log
   */
  devLog("Rendering table with payments:", payments?.length || 0);


  /**
   * Safety fallback
   */
  if (!payments || payments.length === 0) {

    devLog("Rendering empty state");

    return (
      <div className="no-payments">
        No payments found
      </div>
    );

  }


  return (

    <table className="payments-table">

      <thead>
        <tr>
          <th>User Id</th>
          <th>User</th>
          <th>Email</th>
          <th>Plan ID</th>
          <th>Plan</th>
          <th>Amount</th>
          <th>Status</th>
          <th>Order ID</th>
          <th>Date</th>
        </tr>
      </thead>

      <tbody>

        {payments.map((payment) => {

          devLog("Rendering row for paymentId:", payment.id);

          return (

            <tr key={payment.id}>

                <td>
              {payment.userId || "N/A"}
              </td>


              <td>
                {payment.userName || "N/A"}
              </td>

              <td>
                {payment.userEmail || "N/A"}
              </td>

              <td>
                {payment.planId || "N/A"}
              </td>

              <td>
                {payment.planName || "N/A"}
              </td>

              <td>
                ₹{(payment.amount/ 100) || 0}
              </td>

              <td>

                <span
                  className={`status ${
                    payment.status === "SUCCESS"
                      ? "active"
                      : "inactive"
                  }`}
                >
                  {payment.status || "UNKNOWN"}
                </span>

              </td>

              <td>
                {payment.razorpayOrderId || "N/A"}
              </td>

              <td>

                {payment.createdAt
                  ? new Date(payment.createdAt).toLocaleString()
                  : "N/A"}

              </td>

            </tr>

          );

        })}

      </tbody>

    </table>

  );

};

export default PaymentTable;
